import { ChangeEvent } from 'react'

export function mapInputChangeToValue(event: ChangeEvent): string
{
  const target = event.target as HTMLInputElement
  return target.value
}
